import { defineAsyncComponent } from 'vue'

export const ModalPromoCode = defineAsyncComponent(() => import('../ModalPromoCode/ModalPromoCode.vue'))
